import EditedPassword from "./EditedPassword";
export default EditedPassword;
